import loader from '../moduleLoader';
import animateScrollTo from 'animated-scroll-to';
import scrollToWithAnimation from 'scrollto-with-animation'
import { disableScroll, enableScroll } from '../../helpers/scrolling.js';

class Sections {
    constructor(container) {
        this.container = container;
        this.animating = false;
        this.nextPage = this.nextPage.bind(this);
        this.scrollPosition = null;
        this.itemHeight = 0;
        this.timer = null;
        this.scrolling = 0;
        this.teasers = null;

        this.handleTeasersInMobile = this.handleTeasersInMobile.bind(this);
        this.handleHeroImage = this.handleHeroImage.bind(this);
    }

    handleTeasersInMobile(media) {
        if (media.matches) {     
            this.teasers.forEach(element => {
                element.classList.remove('teaser--vertical');                
            });
        } else {
            this.teasers.forEach(element => {
                element.classList.add('teaser--vertical');                
            });
        }
    }

    handleHeroImage() {
        
        const heroes = this.container.querySelectorAll('.hero');
        // heroes.forEach((hero) => {            
        //     const video = hero.querySelector('video');
        //     if(video) {
        //         video.style.width = '';
        //         video.style.height = '';
        //         if(video.offsetHeight < hero.offsetHeight) {
        //             video.style.width = 'auto';
        //             video.style.height = hero.offsetHeight + 'px';
        //         }
        //     }
        // });
    }

    init() {
        this.teasers = this.container.querySelectorAll('.teaser--vertical:not(.teaser--single)');
        
        if(this.teasers != null && this.teasers.length > 0) {            
            var media = window.matchMedia('(max-width: 990px)');
            this.handleTeasersInMobile(media);
            media.addListener(this.handleTeasersInMobile);
        }

        this.handleHeroImage();
        window.addEventListener('resize', this.handleHeroImage);
        window.addEventListener('load', this.handleHeroImage);




    }











    //WIP...
    init__off() {
        this.teasers = this.container.querySelectorAll('.teaser--vertical:not(.teaser--single)');
        
        if(this.teasers != null && this.teasers.length > 0) {
            
            var media = window.matchMedia('(max-width: 990px)');
            this.handleTeasersInMobile(media);
            media.addListener(this.handleTeasersInMobile);
        }


        var scrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        var items = document.querySelectorAll('.sections__inner__item');
        
        for(var i = 0; i < items.length; i++) {

            if(i === 0) continue;

            items[i].classList.add('sections__inner__item--sticky');
            
            if(i === items.length - 1) return;

            var height = items[i].offsetHeight;
            
            window.addEventListener('scroll', function(e) {
                var nextItem = items[this+1];
                var item = items[this]
                var itemDistanceFromTop = nextItem.getBoundingClientRect().top;
                if(itemDistanceFromTop <= height) {
                    item.classList.remove('sections__inner__item--sticky');
                    item.style.transform = 'translateY(400px)';
                }
            }.bind(i));

            window.addEventListener('wheel', function(e) {
                var nextItem = items[this+1];
                var item = items[this]
                var itemDistanceFromTop = nextItem.getBoundingClientRect().top;
                if(itemDistanceFromTop <= height) {
                    item.classList.remove('sections__inner__item--sticky');
                    item.style.transform = 'translateY(400px)';
                }
            }.bind(i));

            // if(nextItemDistanceFromTop === items[i].offsetHeight) {
            //     item.classList.remove('sections__inner__item--sticky');
            // }
        }
        
        
        var i = 0;

        items.forEach(item => {
            i++;
            if(i===1) {return;}
            item.classList.add('sections__inner__item--sticky');
            window.addEventListener('scroll', (e) => {
                var itemDistanceFromTop = item.getBoundingClientRect().top;

                if(scrollPosition >= item.offsetHeight + 400) {
                    item.classList.remove('sections__inner__item--sticky');
                }

                // if(itemDistanceFromTop <= 600 && scrollPosition <= itemDistanceFromTop + item.offsetHeight) {
                //     item.classList.add('sections__inner__item--sticky');
                //     item.style.transform = 'translateY(0)';
                // }
                // else if(scrollPosition > itemDistanceFromTop + item.offsetHeight) {
                //     item.style.transform = 'translateY(400px)';
                //     item.classList.remove('sections__inner__item--sticky');
                // }
                // else {
                //     item.classList.remove('sections__inner__item--sticky');
                // }
            });
        });


        // window.addEventListener('scroll', (e) => {
        //     var scrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

        //     var viewportOffset = el.getBoundingClientRect();
        //     // these are relative to the viewport
        //     var top = viewportOffset.top;
        //     var left = viewportOffset.left;

        //     var height = el.offsetHeight + 400;


        //     if(top <= 600 && scrollPosition <= 1604) {
        //         el.classList.add('sections__inner__item--sticky');
        //         el.style.transform = 'translateY(0)';

        //     }
        //     else if(scrollPosition > 1604) {
        //         el.style.transform = 'translateY(400px)';
        //         el.classList.remove('sections__inner__item--sticky');
        //     }
        //     else {
        //         el.classList.remove('sections__inner__item--sticky');
        //     }
        // });

    



        
        return;

        // setTimeout(() => {
            // var el = document.querySelectorAll('.sections__inner__item')[1];
            // console.log('pos', el.offsetTop);
        // },1000);
        
   
        this.itemHeight = document.querySelector('.sections__inner__item').offsetHeight;

        this.scrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        
        // console.log(window.innerHeight);
        // document.addEventListener('DOMContentLoaded', () => {
            this.hijackScroll();
        
            


        var sections = this.container.querySelectorAll('.hero__image, .hero__video');
        var height = sections[0].parentElement.offsetHeight;

        var scrolling = false;
        var interval;

        window.addEventListener('scroll', (e) => {
            // console.log('scrolling');
            var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
                       
            for(var i = 0; i < sections.length; i++) {
                if(i == 0) continue;



                // (720-(300*i)/300)

       
                // var position = (scrollTop-((height*(i-1))+(height/2)))/height    //(height-(height/2));

                var position = (scrollTop-((height*(i-1)))-(height/2))/(height-(height/2));

                var opacity = position;
                

                // sections[i].parentElement.offsetHeight; //300
                // scrollTop; //720

                // sections[i].parentElement.offsetHeight * i

                // var start = sections[i].parentElement.offsetHeight * i;
                // var end = sections[i].parentElement.offsetHeight * (i + 1);
                
                // console.log(sections[i].parentElement.offsetHeight * i);

                // if(i == 1) {
                //     start = (window.innerHeight/2)
                // }
                // else {
                    // start = (window.innerHeight/2) * i
                // }
                
              
                // console.log(opacity);

                if(opacity <= 1 && opacity >= 0) {
                    sections[i].style.opacity = opacity;
                    sections[i].style.display = 'block';                    
                }
                else if(opacity > 1) {
                    sections[i].style.opacity = 1;
                    sections[i].style.display = 'block';                    
                }
                else {
                    sections[i].style.opacity = 0;
                    sections[i].style.display = 'none';
                }
    
            }




           


                // start = (window.innerHeight)
                // opacity;
                // console.log('start', start);
                // position = scrollTop - start;
                //     opacity = (position/start) * 2;


                // if(opacity <= 1 && opacity >= 0) {
                //     sections[2].style.opacity = opacity;
                //     sections[2].style.display = 'block';                    
                // }
                // else if(opacity > 1) {
                //     sections[2].style.opacity = 1;
                //     sections[2].style.display = 'block';                    
                // }
                // else {
                //     sections[2].style.opacity = 0;
                //     sections[2].style.display = 'none';
                // }

                // if(scale <= 1 && scale >= 0) {
                    
                //     sections[1].querySelector('img').style.transform = 'scale(' + scale + ')';
                // }
                // else if(scale > 1) {
                    
                //     sections[1].querySelector('img').style.transform = 'scale(1)';
                // }
                // else {
                    
                //     sections[1].querySelector('img').style.transform = 'scale(0)';
                // }
                
                // if(scrolling == false) {
                //     console.log('snap');
                //     disableScroll();
                //     animateScrollTo(sections[1], { onComplete: () => {
                //         setTimeout(()=> {
                //             scrolling = false;
                //             enableScroll();
                //         },200)                        
                //     }});
                // }
                // scrolling = true;
            // }
            


        })
    }

    


    nextPage(e) {
        e = e || window.event;
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;  
        var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        var scrollTo;


        var e = window.event || e; // old IE support
        var direction = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
        var delta = Math.abs(e.wheelDelta || -e.detail);
        // console.log(e);
        // console.log('delta', delta);
        // console.log('scrolling', this.scrolling);
        
        // if(this.scrolling != 0 && delta <= this.scrolling) {
        if(this.scrolling != 0 && delta <= this.scrolling) {
            this.scrolling = delta;
            return false;
        }

        

        this.scrolling = delta;
    


        if(e.wheelDeltaY < 0) {

            scrollTo = scrollTop + this.itemHeight;
        }
        else {
            
            scrollTo = scrollTop - this.itemHeight;
        }

        if(scrollTo < 0) {
            return;
        }

        if(this.animating == false) {
            console.log('continue');
                animateScrollTo(scrollTo, {
                    speed:800,
                    cancelOnUserAction: false,                      
                    onComplete: function() {
       
                        setTimeout(()=> {
                            this.animating = false;                        
                        }, 300);

                    }.bind(this)
                });

            this.animating = true;
        }

    }
        

    hijackScroll() {
        if (window.addEventListener) // older FF
            window.addEventListener('DOMMouseScroll', this.nextPage, false);
        window.onwheel = this.nextPage; // modern standard
        window.onmousewheel = document.onmousewheel = this.nextPage; // older browsers, IE
        window.ontouchmove  = this.nextPage; // mobile
        // document.onkeydown  = this.nextPage;
      }
      
    //   enableScroll() {
    //       if (window.removeEventListener)
    //           window.removeEventListener('DOMMouseScroll', preventDefault, false);
    //       window.onmousewheel = document.onmousewheel = null; 
    //       window.onwheel = null; 
    //       window.ontouchmove = null;  
    //       document.onkeydown = null;  
    //   }

    
}

loader.add('Sections', Sections);

export default Sections;